import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import DCENJ from '../../Images/AUTI.jpg';
import '../../css/Global.min.css';
import Competencias from '../../Images/Competencias.jpg';
import Modelo2 from '../../Images/Modelo2.jpg';
import Modalidades from '../../Images/ModalidadEnLinea3.jpg';
import Biblioteca from '../../Images/Biblioteca.jpg';
import Autismo from '../../Images/Autismo.jpg';
import Titulacion from '../../Images/Titulacion.jpg';
import Informes from '../Informes';
import DIngreso from '../../Images/DIngreso.jpg';



class DEAA extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Materias: [],
            Semestres: [],
            Costos: [],
            Inscripcion: "",
            Colegiatura: "",
            Prope: "",
            Actual: '',
            Clave: "AUTI",
            FechaInicio: "",
            FechaLimite: ""

        }


        var xhr = new XMLHttpRequest();
        var principal = this;
        var sobre = { Carrera: this.state.Clave };

        xhr.open("POST", "api/Web/GetPrograma", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                var materias = JSON.parse(xhr.responseText).Table;
                var costos = JSON.parse(xhr.responseText).Table1;
                var fechaInicio = JSON.parse(xhr.responseText).Table2[0].FechaI;
                var fechaLimite = JSON.parse(xhr.responseText).Table2[0].FechaL;
                var prope = costos.find((item) => {
                    if (item.Prope === 1) {
                        return item.Formato
                    }
                });
                var insc = costos.find((item) => {
                    if (item.Prope === 0 && item.id_categoria === 0) {
                        return item.Formato
                    }
                });

                var col = costos.find((item) => {
                    if (item.Prope === 0 && item.id_categoria === 1) {
                        return item.Formato
                    }
                });

                var semestres = [];
                for (let i = 0; i < materias.length; i++) {
                    var buscar = semestres.find((item) => {
                        if (item == materias[i].semestre) {
                            return item;
                        }
                    });

                    if (buscar == null || buscar == undefined) {
                        semestres.push(materias[i].semestre);
                    };
                }
                if (prope === undefined) {
                    prope = { Formato: "" };
                };
                if (insc === undefined) {
                    insc = { Formato: "" };
                };
                if (col === undefined) {
                    col = { Formato: "" };
                };
                if (fechaInicio === undefined) {
                    fechaInicio = "";
                };
                if (fechaLimite === undefined) {
                    fechaLimite = "";
                };
                principal.setState({
                    Materias: materias,
                    Semestres: semestres,
                    Costos: costos,
                    Prope: prope.Formato,
                    Inscripcion: insc.Formato,
                    Colegiatura: col.Formato,
                    FechaInicio: fechaInicio,
                    FechaLimite: fechaLimite
                });

                //principal.iniciarWs(usuario + '|' + xhr.responseText + '|', usuario);
            } else {
                //******** Mensaje a Usuario correcto

                //alert(xhr.status);
                //alert(xhr.responseText);

            }


        };

        if (this.state.Materias.length === 0) {
            xhr.send(JSON.stringify(sobre));
        }
        //xhr.send(JSON.stringify(valores));

        this.materiasSemestre = this.materiasSemestre.bind(this);
        this.semestreTexto = this.semestreTexto.bind(this);
    }

    materiasSemestre(semestre) {
        var materias = [];
        for (let i = 0; i < this.state.Materias.length; i++) {
            if (this.state.Materias[i].semestre == semestre) {
                materias.push(this.state.Materias[i]);
            }
        }

        return materias;
    }

    semestreTexto(semestre) {
        var valor = "";
        switch (semestre) {

            case 1:
                valor = "Primer";
                break;
            case 2:
                valor = "Segundo";
                break;
            case 3:
                valor = "Tercer";
                break;
            case 4:
                valor = "Cuarto";
                break;
            case 5:
                valor = "Quinto";
                break;
            case 6:
                valor = "Sexto";
                break;
            case 7:
                valor = "Séptimo";
                break;
            case 8:
                valor = "Octavo";
                break;
            case 9:
                valor = "Noveno";
                break;
            case 10:
                valor = "D&eacute;cimo";
                break;
            case 11:
                valor = "D&eacute;cimo Primer";
                break;
            case 12:
                valor = "D&eacute;cimo Segundo";
                break;

        }
        return valor;
    }

    componentDidUpdate() {
        if (this.state.Actual != window.location.href) {
            this.state.Actual = window.location.href;
            this.props.reportarVisita(window.location.href, this.state.Clave, false)
        };
    }

    render() {
        return (
            <div>
                <div className="wrapper">
                    <MetaTags>
                        <title>Diplomado en Inclusión en el aula de niños con Autismo</title>
                        <meta name="description" content="Diplomado en Inclusión en el aula de niños con Autismo, conoce las bases psicopedagógicas y las estrategias para integrarlos en el aula" />
                        <meta name="keywords" content="Diplomado, Inclusión, Autismo, en linea, Deficit, Atención, Psicopedagogía" />
                        <meta property="og:title" content="Diplomado en Inclusión en el aula de niños con Autismo" />
                        <meta property="og:description" content="Diplomado en Inclusión en el aula de niños con Autismo, conoce las bases psicopedagógicas y las estrategias para integrarlos en el aula" />
                    </MetaTags>
                </div>
                <div className="content">
                    <div className="ImgenCentral2">
                        <img src={DCENJ} alt="Doctorado en Pedagogía" />
                    </div>
                    <div className="FondoAlterno" style={{ maxWidth: "100%" }}>
                        <div className="Centrado" style={{ maxWidth: "45%", margin: "auto", padding: "50px" }}>
                            <p className="Parrafo1 Centrado" style={{ fontSize: "18pt" }} >
                                El <strong>Diplomado en Inclusión en el aula de niños con Autismo</strong> conoce las fundamentos de los trastornos generalizados del desarrollo, sus orígenes y los medios de intervención educativa de niños con Autismo, mejora su aprendizaje y plantea estrategias para integrarlos en el aula
                                            </p>
                        </div>
                    </div>
                     

                    <div className="CentrarH ListaTabla MarginAA">
                        <ul style={{ marginLeft: "65px" }}>

                            <li>
                                <div className="MiniHistoria">
                                    <img src={Biblioteca} />
                                    <div>
                                        <h3>Biblioteca Digital</h3>
                                        <p>Todos tus recursos siempre disponibles, acceso a m&aacute;s de 300,000 libros e investigaciones completas</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="MiniHistoria">
                                    <img src={Modelo2} />
                                    <div>
                                        <h3>Modelo Educativo</h3>
                                        <p>El seguimiento a nuestros alumnos es importante, clases sabatinas en tiempo real, para solidificar tus aprendizajes y resolver dudas</p>
                                        <p>aplica sólo en modalidad en l&iacute;nea</p>
                                        <a href=''>Ver video explicativo</a>
                                    </div>
                                </div>
                            </li>
                            


                        </ul>
                    </div>
                    
                    <div >
                        <div className="Separador ListaTabla DosColumnas FondoAlterno" >
                            <br />
                            <ul>
                                <li>
                                    <div style={{ textAlign: "right" }}>
                                        <img src={Autismo} alt='Modalidades' style={{ width: "90%" }} />
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <br />
                                        <h2 className="Negrita"><strong>Diplomado 100% en l&iacute;nea</strong></h2>
                                        <h2 className="Negrita"><strong>Duración: 12 semanas</strong></h2>
                                        <br />
                                        <div className="Temario">
                                            <h2>Temario:</h2>
                                            <div>
                                            a) Bases biológicas del autismo
                                            </div>
                                            <div>

                                            b) El autismo. Una perspectiva neuroevolutiva del desarrollo temprano
                                            </div>
                                            <div>

                                            c) Evaluación y diagnóstico de personas con autismo
                                            </div>
                                            <div>

                                            d) Modelos y programas de intervención precoz en niños con trastornos del espectro autista y sus familias
                                            </div>
                                            <div>

                                            e) Conductas desafiantes en niños con trastornos de espectro autista
                                            </div>
                                            <div>

                                            f) Herramientas tecnológicas en la intervención psicoeducativa en niños con trastornos del espectro autista
                                            </div>

                                        </div>

                                    </div>
                                </li>
                            </ul>


                        </div>
                    </div>




                    <div className="Separador ListaTabla2 DosColumnas2 FondoBase" style={{ backgroundColor: "transparent" }}>
                        <ul style={{ width: "80%", margin: "auto" }}>

                            <li>
                                <div style={{ textAlign: "center", backgroundColor: "transparent" }}>
                                    <h2><strong>Documentos de ingreso</strong></h2>
                                    <br />
                                    <table className="Fuente3" style={{ fontSize: "14pt", width: "auto", margin: "auto", textAlign: "left" }}>
                                        <tr>
                                            <td>
                                                - Acta de Nacimiento
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - CURP
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                - Certificado de licenciatura
                                                </td>
                                        </tr>
                                       
                                    </table>
                                    <br />
                                    <div style={{ textAlign: "left", right: "10%", fontSize: "12pt" }}>
                                        <p>
                                            Para la modalidad en l&iacute;nea se entregan documentos escaneados.
                                            </p>
                                        
                                    </div>
                                </div>
                            </li>
                            {this.state.Costos.length > 0 ?

                                <li>
                                    <div className="Centado" style={{ textAlign: "center", backgroundColor: "transparent" }}>
                                        <h2><strong>Costos - Modalidad en l&iacute;nea</strong></h2>
                                        <br />
                                        <table className="Fuente3" style={{ fontSize: "14pt", width: "auto", margin: "auto", textAlign: "left" }}>
                                            
                                            <tr style={{ height: "120px" }}>
                                                <td>
                                                    Costo del diplomado
                                                </td>
                                                <td style={{ textAlign: "right", padding: "15px" }}>
                                                    <div>{this.state.Inscripcion}*</div>
                                                </td>
                                                <td>
                                                    Págalo a 12 meses sin interéses
                                                </td>
                                            </tr>
                                            
                                        </table>

                                    </div>
                                </li>
                                :
                                null
                            }

                        </ul>


                    </div>
                    <Informes solicitarCarrera={() => { return this.state.Clave; }}
                        reportarVisita={this.props.reportarVisita}
                        getGuid={this.props.getGuid}
                        fechaInicio={() => { return this.state.FechaInicio }}
                        fechaLimite={() => { return this.state.FechaLimite }}
                    />
                </div>
            </div>
        );
    }
}

export default DEAA;


// WEBPACK FOOTER //
// ./src/components/Diplomados/AUTI.js